import _extends from "@babel/runtime/helpers/esm/extends";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import React, { cloneElement } from 'react';
import { isFunction } from "../../utils/is-function";
import { TooltipContent } from "./TooltipContent";
import { useTooltip } from "./useTooltip";
import { theme } from "../../theme";
import { wrapEvent } from "../../utils/wrap-event";
import mergeRefs from 'react-merge-refs';
/**
 * Tooltip
 *
 * Handles displaying tooltips using absolute positioning,
 * triggered when the target is hovered.
 */

var defaultOffset = [0, 8];
export function Tooltip(_ref) {
  var isShowingProp = _ref.isShowing,
      onRequestChange = _ref.onRequestChange,
      title = _ref.title,
      details = _ref.details,
      placement = _ref.placement,
      defaultShowing = _ref.defaultShowing,
      _ref$shouldRender = _ref.shouldRender,
      shouldRender = _ref$shouldRender === void 0 ? true : _ref$shouldRender,
      _ref$shouldUsePortal = _ref.shouldUsePortal,
      shouldUsePortal = _ref$shouldUsePortal === void 0 ? true : _ref$shouldUsePortal,
      maxWidth = _ref.maxWidth,
      _ref$delayIn = _ref.delayIn,
      delayIn = _ref$delayIn === void 0 ? 600 : _ref$delayIn,
      _ref$offset = _ref.offset,
      offset = _ref$offset === void 0 ? defaultOffset : _ref$offset,
      className = _ref.className,
      children = _ref.children,
      anchorRef = _ref.anchorRef,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$enableHoverConte = _ref.enableHoverContent,
      enableHoverContent = _ref$enableHoverConte === void 0 ? false : _ref$enableHoverConte,
      _ref$enableOnMobile = _ref.enableOnMobile,
      enableOnMobile = _ref$enableOnMobile === void 0 ? false : _ref$enableOnMobile,
      adornmentBefore = _ref.adornmentBefore,
      adornmentAfter = _ref.adornmentAfter,
      _ref$zIndex = _ref.zIndex,
      zIndex = _ref$zIndex === void 0 ? theme.zIndices.tooltip : _ref$zIndex;

  var _useTooltip = useTooltip({
    isShowing: isShowingProp,
    onRequestChange: onRequestChange,
    defaultShowing: defaultShowing,
    delayIn: delayIn,
    anchorRef: anchorRef,
    disabled: disabled,
    enableHoverContent: enableHoverContent,
    enableOnMobile: enableOnMobile
  }),
      bindTarget = _useTooltip.bindTarget,
      bindContent = _useTooltip.bindContent,
      isShowing = _useTooltip.isShowing;

  var renderChildren = function renderChildren() {
    if (!children) {
      return null;
    } // render callback


    if (isFunction(children)) {
      return children({
        bind: bindTarget,
        isShowing: isShowing
      });
    } // clone the child


    var child = React.Children.only(children);

    var ref = bindTarget.ref,
        onMouseLeave = bindTarget.onMouseLeave,
        onMouseEnter = bindTarget.onMouseEnter,
        onMouseDown = bindTarget.onMouseDown,
        onFocus = bindTarget.onFocus,
        onBlur = bindTarget.onBlur,
        otherBindAttributes = _objectWithoutProperties(bindTarget, ["ref", "onMouseLeave", "onMouseEnter", "onMouseDown", "onFocus", "onBlur"]);

    return cloneElement(child, _objectSpread(_objectSpread({}, otherBindAttributes), {}, {
      ref: mergeRefs([ref, child.ref]),
      onMouseLeave: wrapEvent(onMouseLeave, child.props.onMouseLeave),
      onMouseEnter: wrapEvent(onMouseEnter, child.props.onMouseEnter),
      onMouseDown: wrapEvent(onMouseDown, child.props.onMouseDown),
      onFocus: wrapEvent(onFocus, child.props.onFocus),
      onBlur: wrapEvent(onBlur, child.props.onBlur)
    }));
  };

  return /*#__PURE__*/React.createElement(React.Fragment, null, shouldRender ? /*#__PURE__*/React.createElement(TooltipContent, _extends({}, bindContent, {
    shouldUsePortal: shouldUsePortal,
    placement: placement,
    className: className,
    title: title,
    details: details,
    offset: offset,
    adornmentBefore: adornmentBefore,
    adornmentAfter: adornmentAfter,
    zIndex: zIndex,
    maxWidth: maxWidth
  })) : null, shouldRender ? renderChildren() : children);
}